module.exports = __webpack_public_path__ + "5b5597d293163f25a474d9915eaf6c68.MP3";